export const meta_standard = 'Moose Almighty: Psychedelic Rock from Seattle, Washington';
export const meta_404 = 'Womp womp. Looks like this link is broken.';
export const site_name = 'Moose Almighty';
export const site_url = 'www.moosealmighty.com';
export const site_owner = 'Moose Almighty';
export const ga_tracking_code = 'UA-142206144-1';
export const anonymousUserId = '000000000000000000000000';

export const isDevelopmentMode = document.location.hostname === 'localhost';



// WEBPACK FOOTER //
// ./src/store/constants/meta_info.js